import React from "react";

import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverServiceMigrationActions from "../../../store/actions/DriverServiceMigration";
import BulkUploadFile from "../../BulkUploadFile";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Max upload limit is 1000.",
];

const FileUploadModal = ({ getUploadUrl }) => {
  return (
    <ZomatoToBlinkitMigration>
      <BulkUploadFile
        instructions={instructions}
        btnDataTestID="ZomatoToBlinkitMigrationsActionsUpload"
        uploadUrl="/driver-service-migration/zomato-to-blinkit/bulk-upload/ack"
        sampleURL="/sample/bulk_upload_zomato_to_blinkit_migration.csv"
        id="bulkUploadZomatoToBlinkitMigrationModal"
        sendExtraAck={true}
        keyName="callback_key"
        heading="Bulk Zomato to Blinkit Service Migration"
        getUploadUrl={getUploadUrl}
      />
    </ZomatoToBlinkitMigration>
  );
};

const ZomatoToBlinkitMigration = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      DriverServiceMigrationActions.getZomatoToBlinkitMigrationUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);
